import React from 'react'
import {useTranslation} from 'react-i18next'
import {isMobile} from 'react-device-detect'
import styled from 'styled-components'

const Option = styled.span`
  &:hover {
    color: var(--bs-primary);
  }

`

const FeaturesFilter = (props) => {
  const {machine} = props
  const [current, send] = machine
  const {i18n} = useTranslation()

  const features = [
    { label: i18n.t('features.hotel_pickup'), param: 'location_point_type', value: 'hotel_pickup' },
    // { label: i18n.t('features.evoucher'), param: 'evoucher', value: 'true' },
    { label: i18n.t('features.accessibility_accessible'), param: 'accessibility_grade', value: 'accessible' },
    { label: i18n.t('features.pet_friendly_allowed'), param: 'pet_friendly_grade', value: 'pets_allowed' },
  ]

  const featureFilterd = (param) => current.context.filters.find((filter) => {
    return filter.param === param
  })
  const featureFilterValue = (param) => featureFilterd(param) && featureFilterd(param).value

  const onFeatureFilter = (feature) => {
    if (featureFilterValue(feature.param) === feature.value) {
      send({ type: 'FILTER_REMOVE', param: feature.param })
    } else {
      send({
        type: 'FILTER_SELECTION',
        filter: {
          param: feature.param,
          label: feature.label,
          value: feature.value
        }
      })
    }

    if (isMobile) {
      props.setIsOpen(!props.isOpen)
    }
  }

  return (
    <>
      {features.map((feature) => (
        <div key={feature.value} className="mb-1">
          <input
            type="checkbox"
            className="me-2"
            checked={feature.value === featureFilterValue(feature.param)}
            onChange={() => onFeatureFilter(feature)}
            style={{ cursor: 'pointer' }}
          />
          <label
            onClick={() => onFeatureFilter(feature)}
            style={{ cursor: 'pointer' }}
          >
            <Option className={feature.value === featureFilterValue(feature.param) ? 'fw-semibold' : 'fw-normal'}>{feature.label}</Option>
          </label>
        </div>
      ))}
    </>
  )
}

export default FeaturesFilter
